module.exports = __webpack_public_path__ + "img/nomore.10116efd.png";